import { format, parseISO } from "date-fns";
import { ArchivedStatuses } from "@/components/organisms/Clients/types";

/** A client whose operator access has been removed gets the view-only banner (DEV-1177). */
export const isClientAccessRemoved = (status?: string | null): boolean => !!status && ArchivedStatuses.includes(status);

/**
 * Builds the view-only banner copy. The date clause is dropped when removed_at is
 * absent (e.g. legacy rows removed before the column existed) rather than printing
 * an "Invalid Date".
 */
export const getRemovedAccessBannerText = (operatorName: string, removedAt: string | null | undefined, dateFormat: string): string => {
  const datePart = removedAt ? ` on ${format(parseISO(removedAt), dateFormat)}` : "";
  const subject = `${operatorName}${datePart}`;
  // Avoid a double period when the operator name already ends in one (e.g. "Demo Co.").
  const fullStop = subject.endsWith(".") ? "" : ".";
  return `View-only access. This client was removed from ${subject}${fullStop} You can no longer edit or book trips for this client.`;
};
